import { gql, useMutation } from '@apollo/client'

export const useMutateProject = () => {
  const [archiveProjectMutation] = useMutation(
    gql(`mutation ArchiveProject($projectId: ID!) {
            archiveProject(projectId: $projectId) {
                id
                status
            }
        }`),
  )
  const [renameProjectMutation] = useMutation(
    gql(`mutation RenameProject($projectId: ID!, $name: String!) {
            renameProject(projectId: $projectId, name: $name) {
                id
                name
            }
        }`),
  )

  return {
    archive: (projectId: string) => {
      return archiveProjectMutation({
        variables: {
          projectId,
        },
        optimisticResponse: {
          archiveProject: {
            id: projectId,
            status: 'INACTIVE',
          },
        },
      })
    },
    rename: (projectId: string, name: string) => {
      return renameProjectMutation({
        variables: {
          projectId,
          name,
        },
        optimisticResponse: {
          renameProject: {
            id: projectId,
            name,
          },
        },
      })
    },
  }
}
